const ROUTES = {
  DASHBOARD: '/dashboard',
  USERS: '/users',
  USER_DETAIL: '/users/:id',
  DRIVERS: '/drivers',
  DRIVER_DETAIL: '/drivers/:id',
  TRIPS: '/trips',
  TRIP_DETAIL: '/trips/:id',
  TRIP_LOGS: '/trip-logs',
  LOCATION_SMART_MAP: '/location/smart-map',
  LOCATION_ACTIVE_DRIVERS: '/location/active-drivers',
  COMMUNICATION_CHAT: '/communication/chat',
  COMMUNICATION_NOTIFICATIONS: '/communication/notifications',
  COMMUNICATION_BULK_SMS: '/communication/bulk-sms',
  COMMUNICATION_CONTACT: '/communication/contact',
  PAYMENTS_PENDING: '/payments/pending',
  PAYMENTS_COMPLETED: '/payments/completed',
  PAYMENTS_BANK_TRANSFER: '/payments/bank-transfer',
  SETTINGS_GENERAL: '/settings/general',
  SETTINGS_REGION: '/settings/region',
  SETTINGS_VEHICLE_TYPES: '/settings/vehicle-types',
  SETTINGS_DISTANCE_DISCOUNTS: '/settings/distance-discounts',
  SETTINGS_SUBSCRIPTION_PLANS: '/settings/subscription-plans',
  SETTINGS_DRIVER_DISCOUNTS: '/settings/driver-discounts',
  SETTINGS_AGREEMENTS: '/settings/agreements',
  SETTINGS_SYSTEM_LOGS_SMS: '/settings/system-logs/sms',
  SETTINGS_FAQ: '/settings/faq',
  SETTINGS_PAGES: '/settings/pages',
  SETTINGS_BANK_ACCOUNTS: '/settings/bank-accounts',
  SUBSCRIPTIONS_DRIVERS: '/subscriptions/drivers',
  SUBSCRIPTIONS_AUDIT_LOGS: '/subscriptions/audit-logs',
  SUBSCRIPTIONS_STATISTICS: '/subscriptions/statistics',
  CRM: '/crm',
  CUSTOMER_MESSAGES: '/customer-messages',
  PROFILE: '/profile',
  LOGIN: '/login',
  NOT_FOUND: '*',
  ROOT: '/',
  AUTHORIZED_USERS: '/authorized-users',
  MOBILE: '/mobile',
  MOBILE_SMART_MAP: '/mobile/smart-map',
  MOBILE_USERS: '/mobile/users',
  MOBILE_DRIVERS: '/mobile/drivers',
  MOBILE_TRIPS: '/mobile/trips',
  MOBILE_LIVE_RIDES: '/mobile/live-rides',
  MOBILE_NOTIFICATIONS: '/mobile/notifications',
  MOBILE_METRICS_OVERVIEW: '/mobile/metrics/overview',
  MOBILE_METRICS_DRIVERS: '/mobile/metrics/drivers',
  MOBILE_METRICS_PASSENGERS: '/mobile/metrics/passengers',
  MOBILE_METRICS_PERFORMANCE: '/mobile/metrics/performance',
  MOBILE_METRICS_COVERAGE: '/mobile/metrics/coverage',
  OPERATIONAL_METRICS: '/operational-metrics',
  OPERATIONAL_METRICS_OVERVIEW: '/operational-metrics/overview',
  OPERATIONAL_METRICS_DRIVERS: '/operational-metrics/drivers',
  OPERATIONAL_METRICS_PASSENGERS: '/operational-metrics/passengers',
  OPERATIONAL_METRICS_PERFORMANCE: '/operational-metrics/performance',
  OPERATIONAL_METRICS_COVERAGE: '/operational-metrics/coverage',
  OPERATIONAL_METRICS_ACCEPTANCE_CANCELLATION: '/operational-metrics/acceptance-cancellation',
  OPERATIONAL_METRICS_DRIVER_PENALTIES: '/operational-metrics/driver-penalties',
  MOBILE_METRICS_ACCEPTANCE_CANCELLATION: '/mobile/metrics/acceptance-cancellation',
};

export default ROUTES; 